import React from 'react';

interface DothProps {
    fill?: string;
}

export const Doth = ({ fill }: DothProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="3" viewBox="0 0 2 3" fill="none">
        <circle cx="1" cy="1.5" r="1" fill={fill} />
    </svg>
);
